import './lib/polyfills/'
// import './lib/ripples'
import 'whatwg-fetch'
import './fontawesome-library'
import FastClick from 'fastclick'
import moment from './lib/moment'
import throttle from 'lodash/throttle'

import React from 'react'
import ReactDOM from 'react-dom'

import { createStore, applyMiddleware } from 'redux'
import { loadState, saveState } from './localStorage'
import { Provider } from 'react-redux'
import thunkMiddleware from 'redux-thunk'
import { createLogger } from 'redux-logger'

import rootReducer from './reducers'
import {
  selectTideStation,
  selectDate,
  startUpdatingNowMomentEveryMinute,
  updateLocationSearch,
} from './actions/uiActions'

import App from './components/App'
import registerServiceWorker, { unregister as unregisterServiceWorker } from './registerServiceWorker'






// =========================
// = Init helper utilities =
// =========================

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function() {
        FastClick.attach(document.body);
    }, false);
}









// ====================
// = Init redux store =
// ====================

// Apply middlewear
let appliedMiddleware
if (process.env.REACT_APP_ENV === 'development') {
  // Development settings
  const logger = createLogger({
    collapsed: true,
    diff: false
  })
  appliedMiddleware = applyMiddleware(
    thunkMiddleware,
    logger
  )
}
else {
  // Production & test settings
  appliedMiddleware = applyMiddleware(
    thunkMiddleware
  )
}

const persistedState = loadState()
const store = createStore(rootReducer, persistedState, appliedMiddleware)

store.subscribe(throttle(() => {
  saveState(store.getState())
}, 1000))




// =============================
// = Dispatch initial settings =
// =============================

const { dispatch } = store

// Start timer to update the `now` value every minute
dispatch(startUpdatingNowMomentEveryMinute())
window.set_time_to = function(h,m) {return dispatch({type: 'UPDATE_NOW_MOMENT', now: moment().hour(h).minutes(m)})}

// Set selectedDay to today, and don't fetch tides yet
dispatch(selectDate(moment(), false))
// dispatch(selectDate(moment('2018-01-29'), false))


// If there's a recently visited tide station, select it.
// Otherwise, leave it blank and fetch user location in the
// background
const recentStation = store.getState().ui.visitedTideStations[0]
if (recentStation) {
  dispatch(selectTideStation(recentStation, true))
  dispatch(updateLocationSearch({query: recentStation.name}))
}

// Skip landing page and go directly to a station if REACT_APP_SKIP_LANDING_PAGE
// is true
else if (process.env.REACT_APP_SKIP_LANDING_PAGE === 'true') {
  dispatch(selectTideStation('8418175', true))
  // dispatch(selectTideStation('9413745', true))
}










// =====================================
// = Attach React & Redux store to DOM =
// =====================================

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
)

if (process.env.REACT_APP_ENV === 'staging')
  unregisterServiceWorker()
else
  registerServiceWorker()







window.store = store
window.dispatch = dispatch
window.moment = moment



// WEBPACK FOOTER //
// ./src/index.js